import { QuestionCircle, QuestionCircleFill } from 'react-bootstrap-icons';
import { useState } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import './Help.css';

const HoverHelp = ({ id, text }) => {
    const [hover, setHover] = useState(false);

    return (
        <OverlayTrigger
            placement="right"
            overlay={<Tooltip id={`tooltip-${id}`}>{text}</Tooltip>}
        >
            <span
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
                style={{ display: "inline-block" }}
            >
                {!hover && <QuestionCircle className="mt-1 help-icon-hover" />}
                {hover && <QuestionCircleFill className="mt-1 help-icon-hover" />}
            </span>
        </OverlayTrigger>
    );
};

export default HoverHelp;
